<template>

  <div class="PayBill">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >

  <b-container fluid style="padding-top: 20px;text-align:left;display:block" id="consBillDiv" >
    <b-row >
      <b-col cols="12">
        <span class="title" style="font-size:1.5rem;">Recharge Prepaid Meter</span>
      </b-col>
    </b-row>
    <hr/>
    <div style="padding-left:30px;  ">

      <!-- <br>
      <p style="color:red">We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.</p>
 -->

    <br>
    <b-row>
      <b-col cols=12 style="padding-top: 7px;">
            <span style="font-weight:600" >Consumer No <span class="text-danger">*</span></span>
      </b-col>
    </b-row>
    </br>
    <b-row>
      <b-col cols=10>
          <b-form-input type="text" maxlength="12" id="consNo" value=""  placeholder="Enter Prepaid Consumer Number" trim required />
      </b-col>
      <b-col cols=2 >
            <b-button id="submitBtn" @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
              <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
            </b-button>
      </b-col>
    </b-row>

</br>
    <div id="BillDetails" class="billDetails">
      <b-row>
        <b-col cols=12>
            <span class="heading">Bill Details</span>
        </b-col>
      </b-row>
      <hr/>

    <b-row class="brow">
      <b-col cols=3><span class="label">Consumer Name : </span></b-col>
      <b-col><span class="" id="consName"> </span></b-col>
    </b-row>

    <b-row class="brow">
      <b-col cols=3><span class="label">Location : </span></b-col>
      <b-col><span class="" id="subDiv"> </span></b-col>
    </b-row>

    <b-row class="brow">
      <b-col cols=3><span class="label">Meter No : </span></b-col>
      <b-col><span class="" id="meterNo"> </span></b-col>
    </b-row>
    <!-- <b-row class="brow">
      <b-col cols=3><span class="label">Category : </span></b-col>
      <b-col><span class="" id="category">  </span></b-col>
    </b-row> -->
    <b-row class="brow">
      <b-col ><span class="label">Amount <span class="text-danger">*</span> :    </span></b-col>
    </b-row>
    <b-row class="brow">
      <b-col><b-form-input type="number" id="amount" placeholder="Recharge  Amount" trim ></b-form-input></b-col>
    </b-row>
    <b-row class="brow">
      <b-col style="font-weight:600">  Mobile No <span class="text-danger">*</span> </b-col>
    </b-row>
    <b-row class="brow">
      <b-col>  <b-form-input type="number" id="mobileNo" placeholder="Enter Mobile No" trim /></b-col>
    </b-row>
    <b-row class="brow">
      <b-col style="font-weight:600">  Email ID </b-col>
    </b-row>
    <b-row class="brow">
      <b-col > <b-form-input type="email" id="emailId" placeholder="Enter Email ID" trim /> </span></b-col>
    </b-row>

  <br>
    <b-row>
          <b-col cols=12 offset=0>

              <b-button block squared variant="primary" @click="payNow()">
               <b-icon icon="credit-card" animation=""  >  </b-icon> PAY NOW
             </b-button>

          </b-col>
        </b-row>
      </div>
  </div>
  </b-container>
  <b-container fluid style="padding-top: 50px;text-align:left;display:none" id="billdeskRequestDiv">

  <b-row id="spinner" style="display:block">
    <b-col cols=12 align="center">
      <h3 class="">Processing Payment Request...</h3>
      <br><br>
        <b-spinner style="width: 10rem; height: 10rem;" variant="primary" label="Spinning"></b-spinner>
      <br><br><br>
       <h5 style="color:red">Please do not press back or refresh button</h5>
    </b-col>
  </b-row>
  <b-row id="errorDiv" style="display:none">
    <b-col cols=12 align="center">
      <h2 style="color:red" id="errorMsg"></h2>
      <br><br>
      <b-button onclick="window.location.reload();">Go Back</b-button>
    </b-col>
  </b-row>
</b-container>
<br><br>
</b-overlay>

<form :action = "reqUrl" method="post" id="pgrequest" hidden>
    <input type="" name="msg" :value = "messageToSend" hidden>
    <input type="submit" id="submit" value="submit" hidden>
</form>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>
  </div>

</template>


<script>

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var consNo="";
var sdCode = "";


//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";

export default {

  data() {
    return {
      show: false,
      message : [
        "",
        "No Consumer Found for this Consumer Number",
        "No Outstanding Bill Found for this Consumer Number",
        "This Consumer Number is Blocked",
        "No Bill Found for Payment",
        "",
        "Server Busy! Kindly Try Again After Sometime.",
        "Transaction Already in Progress",
        "Error in Initiating Payment Request with Billdesk"
      ],
      reqUrl : "",
      messageToSend : "",

    }
  },
  mounted()
  {
  var url_string = window.location.href;
   var url = new URL(url_string);
   var consNo = url.searchParams.get("consNo");
   console.log("Cons No===="+consNo)
   if(consNo!=null)
     {

       document.getElementById("consNo").value=consNo;
       document.getElementById("submitBtn").click();
     }
   else
     {

     document.getElementById("consNo").value="";
     }
  },
  methods: {
    showDetails() {
      consNo = document.getElementById("consNo").value;
      var parent = this;
    if (consNo.toString().length==0)
        {
          this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
        }
        else{
          parent.show= true;
          axios.post(this.$urlCommon+ '/api/web/prepaidRecharge?consNo='+consNo)
          .then((response) => {
            console.log(response.data);

            var data=response.data;
            var msg=data.isValid;

            if(msg=="Valid") {
              sdCode = data.sdCode;
              document.getElementById("consName").innerHTML=data.consumerName;
              document.getElementById("subDiv").innerHTML=data.address;
              document.getElementById("meterNo").innerHTML=data.meterNo;
              // document.getElementById("category").innerHTML=data.categoryName;
              parent.show= false;
              document.getElementById("BillDetails").classList.add("showBillDetails");
            }


            else
            {
              parent.show= false;
              parent.$bvModal.show("model");
              document.getElementById("msg").innerHTML=data.errorcode;
              document.getElementById("BillDetails").classList.remove("showBillDetails");
            }



          })
        .catch((e) => {
        console.log("Caught", e);
        parent.show= false;
        parent.$bvModal.show("model");
        document.getElementById("msg").innerHTML=e;
        document.getElementById("BillDetails").classList.remove("showBillDetails");
      })

        }
      },

    payNow()
    {

      var mobileNo = document.getElementById("mobileNo").value;
      var emailId = document.getElementById("emailId").value;
      var amountPaid = document.getElementById("amount").value;
      console.log(emailId);
        if (emailId=="")
      {
        emailId="NA";
      }
      if (amountPaid<100 || amountPaid>5000 )
          {
            this.$bvToast.toast('Enter Amount between Rs. 100.00 - Rs. 5000.00 !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("amount").focus();
            return
          }

          if ((parseInt(amountPaid)%100)!= 0 )
              {
                this.$bvToast.toast('Enter Amount Multiple of 100 !', {
                  title: `Alert`,
                  variant: 'danger',
                  solid: true
                })
                document.getElementById("amount").focus();
                return
              }

      if (mobileNo.length!=10)
          {
            this.$bvToast.toast('Enter 10 Digit Mobile Number !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("mobileNo").focus();
            return
          }

    //  window.location.href="/website/BilldeskRequestPrepaid?consNo="+this.consumerNo+"&subDiv="+this.subDiv+"&amountPaid="+amountPaid+"&mobileNo="+mobileNo+"&emailId="+emailId;
    axios.post( "https://www.apdcl.org/restapi/RestAPI/website/consDetailsUpdateFromEasyPay?consNo="+consNo+"&mobNo="+mobileNo)
    .then((response) => {
      console.log(response.data);
    })
    document.getElementById("consBillDiv").style.display="none";
    document.getElementById("billdeskRequestDiv").style.display="block";
    var parent=this;
    axios.post( this.$urlCommon+'/api/onlineprepaid/pgrequest?consNo='+consNo+'&subDiv='+sdCode+"&amountPaid="+amountPaid+"&mobileNo="+mobileNo+"&email="+emailId)
    .then((response) => {
      console.log(response.data);
      var data=response.data;
      var status=response.data.message;

      if(status=="00") {
        parent.reqUrl = data.action;
        parent.messageToSend= data.msg;
        setTimeout(function(){ document.getElementById("submit").click(); }, 2000);
      }
      else
      {

        document.getElementById('spinner').style.display = 'none';
        document.getElementById('errorDiv').style.display = 'block';
        document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
        this.$bvModal.show("model");
        document.getElementById("msg").innerHTML=this.message[parseInt(status)];
        //document.getElementById("BillDetails").classList.remove("showBillDetails");
      }


    })
    .catch((e) => {
      parent.show= false;
      parent.$bvModal.show('model');
      document.getElementById("msg").innerHTML="Sorry, Please Try Again Later";
      console.log("Caught :::::::::::::::", e.message);

  })

    },
    closeModal(){
      this.$bvModal.hide('model')
    }


  }
}


</script>

<style scoped="true">
.brow{
  padding-top:0.5rem;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.billDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
}
.showBillDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
</style>
